import { ManageDocumentTemplatesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCanManageDocumentTemplates = () => {
  const { data } = useQuery(ManageDocumentTemplatesDocument)

  return data?.documents._policies.templateManageDocumentTemplates.can
}
